import type { LocationQuery } from 'vue-router'
import { isTrackingAttributionQueryParameter } from '~/composables/trackingAttribution'

/**
 * @description Append UTM codes and click IDs from query to the route.
 * @param route {string} The route to transform
 * @returns {string} The updated route
 */
export function appendQueryParameters(route: string, query: LocationQuery): string {
  const queryParameters = new URLSearchParams()

  Object.keys(query).forEach((key) => {
    if (isTrackingAttributionQueryParameter(key) || key.toLowerCase() === 'promo' || key.toLowerCase() === 'gexp') {
      const values = Array.isArray(query[key]) ? query[key] : [query[key]]
      values.forEach((value) => {
        if (value !== null && value !== undefined) {
          queryParameters.append(key, String(value))
        }
      })
    }
  })

  const encodedQuery = queryParameters.toString()
  return encodedQuery ? `${route}&${encodedQuery}` : route
}
